import React, { useState, useEffect } from 'react'
import { Box, Card, CardContent, CardHeader, Grid, TextField, Button, Stack } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'; import CancelIcon from '@mui/icons-material/Cancel'; import SearchIcon from '@mui/icons-material/Search'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import { useSnackbar } from 'notistack'
import normaService from '../services/normaService'; import crudsService from '../services/crudsService'
import CrudTable from '../components/common/CrudTable'; import PageHeader from '../components/common/PageHeader'
import ConfirmDialog from '../components/common/ConfirmDialog'

const COLUMNS = [
  { field: 'descripcion', header: 'Descripción' },
  { field: 'email', header: 'Email' },
]

export default function OficinaNotif() {
  const { enqueueSnackbar } = useSnackbar()
  const [casoUso, setCasoUso] = useState('new'); const [id, setId] = useState(''); const [desc, setDesc] = useState(''); const [email, setEmail] = useState(''); const [buscar, setBuscar] = useState('')
  const [rows, setRows] = useState([]); const [loading, setLoading] = useState(false); const [confirmOpen, setConfirmOpen] = useState(false); const [rowToDelete, setRowToDelete] = useState(null)

  useEffect(() => { loadData() }, [])

  const loadData = (filtro = '') => {
    setLoading(true)
    normaService.getOficinaNotif(null, filtro || undefined).then(res => setRows(res.data?.data || []))
      .catch(() => enqueueSnackbar('Error al cargar oficinas notif', { variant: 'error' })).finally(() => setLoading(false))
  }

  const clearForm = () => { setCasoUso('new'); setId(''); setDesc(''); setEmail('') }
  const handleEdit = (row) => { setCasoUso('edit'); setId(row.id); setDesc(row.descripcion); setEmail(row.email) }
  const handleDeleteRequest = (row) => { setRowToDelete(row); setConfirmOpen(true) }

  const handleDeleteConfirm = async () => {
    setConfirmOpen(false)
    try {
      await crudsService.oficinaNotif('delete', { id: rowToDelete.id })
      enqueueSnackbar('Oficina Notif eliminada', { variant: 'success' }); loadData(buscar)
    } catch { enqueueSnackbar('Error al eliminar', { variant: 'error' }) }
    setRowToDelete(null)
  }

  const handleAceptar = async () => {
    if (!desc.trim() || !email.trim()) { enqueueSnackbar('Complete todos los campos', { variant: 'warning' }); return }
    const object = { descripcion: desc, email }; if (casoUso === 'edit') object.id = id
    try {
      const res = await crudsService.oficinaNotif(casoUso, object)
      if (res.data?.code !== undefined) {
        enqueueSnackbar(`Oficina Notif ${casoUso === 'new' ? 'agregada' : 'actualizada'}`, { variant: 'success' }); clearForm(); loadData(buscar)
      } else {
        enqueueSnackbar('Error al guardar', { variant: 'error' })
      }
    } catch { enqueueSnackbar('Error al guardar', { variant: 'error' }) }
  }

  return (
    <Box>
      <PageHeader title="Oficina Notif." subtitle="Gestión de notificaciones de oficina" icon={NotificationsActiveIcon} />
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardHeader title={casoUso === 'new' ? 'Nueva Notif.' : 'Editar Notif.'} titleTypographyProps={{ variant: 'subtitle1', fontWeight: 600 }} />
            <CardContent>
              <Stack spacing={2}>
                <TextField fullWidth size="small" label="Descripción *" value={desc} onChange={e => setDesc(e.target.value)} inputProps={{ maxLength: 200 }} />
                <TextField fullWidth size="small" label="Email *" value={email} onChange={e => setEmail(e.target.value)} type="email" inputProps={{ maxLength: 100 }} />
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                  <Button variant="outlined" startIcon={<CancelIcon />} onClick={clearForm} size="small">Cancelar</Button>
                  <Button variant="contained" startIcon={<SaveIcon />} onClick={handleAceptar} size="small">{casoUso === 'new' ? 'Agregar' : 'Actualizar'}</Button>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={8}>
          <Card>
            <CardHeader title="Listado" titleTypographyProps={{ variant: 'subtitle1', fontWeight: 600 }}
              action={<Stack direction="row" spacing={1} alignItems="center">
                <TextField size="small" placeholder="Buscar..." value={buscar} onChange={e => setBuscar(e.target.value)} onKeyDown={e => e.key === 'Enter' && loadData(buscar)} sx={{ width: 160 }} />
                <Button size="small" variant="outlined" startIcon={<SearchIcon />} onClick={() => loadData(buscar)}>Buscar</Button>
              </Stack>} />
            <CardContent sx={{ p: 0 }}>
              <CrudTable columns={COLUMNS} rows={rows} loading={loading} onEdit={handleEdit} onDelete={handleDeleteRequest} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <ConfirmDialog open={confirmOpen} title="Eliminar Oficina Notif" message={`¿Confirma la eliminación de "${rowToDelete?.descripcion}"?`}
        onConfirm={handleDeleteConfirm} onCancel={() => { setConfirmOpen(false); setRowToDelete(null) }} />
    </Box>
  )
}
